export default __webpack_public_path__ + "static/media/2.af266861.png";